import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'caseGroupCreationProccodesPipe',
  pure: true
})
export class CaseGroupCreationProccodesPipePipe implements PipeTransform {

  transform(codesData: any[], searchTermproc: string): any[]  {
    if (!codesData || !searchTermproc) { return codesData; }
    return codesData.filter(ad =>
     
    
      ad.name.toLowerCase().indexOf(searchTermproc.toLowerCase().trim()) !== -1

    


    );
  }

}
